import { AxiosResponse } from 'axios'
import { $axios } from './axios'
import { CreateBrandDetailsType, BrandDetailsType } from '../../server/models/BrandDetails'

export const createBrandDetails = (
  body: CreateBrandDetailsType
): Promise<AxiosResponse<BrandDetailsType>> => {
  return $axios.post(`/brand-details`, body)
}

export const getMyBrandDetails = (): Promise<AxiosResponse<BrandDetailsType[]>> => {
  return $axios.get(`/brand-details`)
}
